var map = {
	"./actuallyPriceNotPoints.png": "462a",
	"./actuallyPricePoints.png": "2fc5",
	"./actuallyPriceSum-icon.png": "36b4",
	"./actuallyPriceSum.png": "fef9",
	"./agentOrderCount-icon.png": "1d04",
	"./agentSaleAmount-icon.png": "21e1",
	"./bg_login.png": "1c69",
	"./commodity-active-icon.png": "b0a6",
	"./commodity-inactive-icon.png": "263d",
	"./default.png": "113c",
	"./directOrderCount-icon.png": "6126",
	"./directSaleAmount-icon.png": "602e",
	"./downward-icon.png": "2556",
	"./exchangeAmountExcludingTax-icon.png": "d95c",
	"./exchangeRate-icon.png": "014a",
	"./font/AlibabaPuHuiTi-2-105-Heavy.ttf": "1892",
	"./font/AlibabaPuHuiTi-2-115-Black.ttf": "975c",
	"./font/AlibabaPuHuiTi-2-35-Thin.ttf": "2a98",
	"./font/AlibabaPuHuiTi-2-45-Light.ttf": "608f",
	"./font/AlibabaPuHuiTi-2-55-Regular.ttf": "5935",
	"./font/AlibabaPuHuiTi-2-65-Medium.ttf": "83e2",
	"./font/AlibabaPuHuiTi-2-75-SemiBold.ttf": "74be",
	"./font/AlibabaPuHuiTi-2-85-Bold.ttf": "2709",
	"./font/AlibabaPuHuiTi-2-95-ExtraBold.ttf": "0cb8",
	"./icon_12@2x.png": "5df22",
	"./icon_16@2x.png": "ba55",
	"./icon_16_2@2x.png": "fcd6",
	"./icon_24@2x.png": "8343",
	"./icon_arrow_down@2x.png": "4ac3",
	"./icon_arrow_up@2x.png": "ca2a",
	"./icon_entry_distribution@2x.png": "6f02",
	"./icon_entry_goods@2x.png": "5e7a",
	"./icon_entry_order@2x.png": "5b13",
	"./icon_entry_user@2x.png": "031c",
	"./icon_home@2x.png": "4348",
	"./icon_menu_32@2x.png": "ccde",
	"./icon_order_comment@2x.png": "0c5e",
	"./icon_order_receive@2x.png": "d8fe",
	"./icon_order_send@2x.png": "5c22",
	"./logo.png": "cf05",
	"./logo_login@2x.png": "cb1a",
	"./no1-icon.png": "48cb",
	"./numberExchangeParticipants-icon.png": "845d",
	"./numberPurchasers-icon.png": "9d08",
	"./ranking-icon.png": "7fbb",
	"./salesAmountExcludingTax-icon.png": "9d24",
	"./salesVolumeExcludingTax-icon.png": "6968",
	"./serve-active-icon.png": "5280",
	"./serve-inactive-icon.png": "d4de",
	"./upward-icon.png": "7a79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";